export default __webpack_public_path__ + "static/media/Copy of 31-Make-Remote-Access-Secure-Access.54d4de47.jpg";